import React from "react";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import JobPostingFormPresenter from "./JobPostingFormPresenter";
import Hierarchy from "../../../../components/common/Hierarchy";
import FormFactory from "../../../../components/FormFactory";

class JobpostingViewPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      hierarchy: {},
      advanced: false,
      positionTitle: [],
      salaryGrade: [],
      selectedTitle: "",
      item_number: "",
      selectedSalary: {},
      typeApplication: "",
      typeApplicant: "",
      compensation: "",
      education: "",
      eligibility: "",
      experience: "",
      training: "",
      generalscopeofwork: "",
      qualificationstandard: "",
      dutiesandresponsibilities: "",
      corecompetencies: "",
      organizationalcompetencies: "",
      leadershipcompetencies: "",
      technicalcompetencies: "",
      otherqualifications: "",
      deadlineofsubmission: undefined,
    };
    this.presenter = new JobPostingFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "job_postings";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const positionTitle = await findObjectUseCase().execute("position_titles", {
      include: ["salaryPointer"],
    });
    const salaryGrade = await findObjectUseCase().execute("salary_grade");
    // const office = await findObjectUseCase().execute("offices");
    // const division = await findObjectUseCase().execute("Division");

    this.setState({ positionTitle, salaryGrade });
  }

  dateFormat(data) {
    if (data !== undefined) {
      return new Date(data).toISOString().split("T")[0];
    } else {
      return "";
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      const { submissionDeadline, positionTitle, ...rest } = this.state.object;
      // console.warn("data: ", submissionDeadline);
      // const formattedDeadline = new Date(submissionDeadline)
      //   .toISOString()
      //   .split("T")[0];
      const formattedDeadline = this.dateFormat(submissionDeadline);
      this.setState({
        ...rest,
        selectedTitle: positionTitle,
        deadlineofsubmission: formattedDeadline,
        hierarchy: this.state.object,
      });
    }
  }

  onClickAdvance() {
    this.setState((prevState) => ({ advanced: !prevState.advanced }));
  }

  async handleSelectedTitle(selectedTitle) {
    console.log("TITLE: ", selectedTitle);
    const selected = this.state.positionTitle.find(
      (data) => data.position_title === selectedTitle?.position_title
    );
    console.log("SELECTED: ", selected);
    const hierarchy = {
      region: selected?.region,
      office: selected?.office,
      division: selected?.division,
      section: selected?.section,
      unit: selected?.unit,
      cluster: selected?.cluster,
    };
    if (selected) {
      this.setState({
        selectedTitle,
        item_number: selected?.item_number,
        selectedSalary: selected?.salaryPointer,
        compensation: selected?.other_compensation,
        education: selected?.education,
        eligibility: selected?.eligibility,
        experience: selected?.experience,
        training: selected?.training,
        hierarchy,
      });
    } else {
      this.setState({
        selectedTitle,
        item_number: "",
        selectedSalary: "",
        compensation: "",
        education: "",
        eligibility: "",
        experience: "",
        training: "",
        hierarchy,
      });
    }

    console.warn("selc: ", selected);
  }

  handleInputChange = (field) => (value) => {
    console.log("field", field, "value", value);
    if (field === "selectedSalary") {
      console.log("Value: ", value);
      this.setState({ [field]: value });
    }
    this.setState({ [field]: value });
  };

  handleObjectChange(hierarchy) {
    const object = {
      region: hierarchy.selectedregions,
      office: hierarchy.selectedoffices,
      division: hierarchy.selecteddivisions,
      section: hierarchy.selectedsections,
      unit: hierarchy.selectedunits,
      cluster: hierarchy.selectedplantilla,
    };
    // this.setObject(...object);
    this.setState({ hierarchy: object });
  }

  render() {
    const { object } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row">
                    <FormFactory
                      schema={schema}
                      className="col-lg-6 mb-2"
                      object={object}
                      disabled={true}
                      onChange={this.onChange.bind(this)}
                      excludeFields={[]}
                    />
                  </div>
                  <div className="mt-4">
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(JobpostingViewPage);
